import _ from "lodash";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { setSidebarMenuStructure } from "../../../stateManagement/reducers/SidebarBlockSlice";
import { getClearedFromHiddenItemsMenuStructure, defineAdditionalMenuItemsGroups, defineAdditionalMenuItemsForMainMenu, defineMapMenuItems, defineTableOrAnalyticsMenuItems, getClearedFromEmptySectionsMenuStructure, menuSectionsForEmptyCheck, addDefaultAdditionalMenuItems } from "./menuListFunctions";
import MenuListItem from "./MenuListItem";
import { defaultEndMapMenuItems, defaultMenuStructure } from "./defaultMenuPatterns";
import { logoutApp } from "../../../features/auth/logout";

export default function MenuList() {
    const dispatch = useDispatch()
    const currentMenuStructure: any = useAppSelector(state => state.sidebar.sidebarMenuStructure)
    const currentMenuPath: any = useAppSelector(state => state.sidebar.sidebarMenuPath)
    const currentMenuItems: any = _.get(currentMenuStructure, currentMenuPath.map((index: any) => `[${index}].children`).join(''), currentMenuStructure)
    const objectTypesStructure = getItemWebStorage('objectTypesStructure');

    useEffect(() => {
        if (objectTypesStructure) {
            const currentConfig = getItemWebStorage('currentConfig')
            const { menuShow, mapAdditionalItems, tableAdditionalItems, additionalItemsGroups, menuAdditionalItems } = currentConfig ?? {}
            let menuStructure = structuredClone(defaultMenuStructure)
            // Формирование вкладок из раздела "Карта"
            let mapMenuItems = defineMapMenuItems(objectTypesStructure, menuShow)
            const additionalMapMenuItems: any = defineAdditionalMenuItemsForMainMenu(mapAdditionalItems)
            if (Array.isArray(defaultEndMapMenuItems)) {
                mapMenuItems = [...mapMenuItems, ...defaultEndMapMenuItems]
            }
            if (Array.isArray(additionalMapMenuItems)) {
                mapMenuItems = [...mapMenuItems, ...additionalMapMenuItems]
            }
            // Формирование вкладок из раздела "Таблицы"
            let tableMenuItems = defineTableOrAnalyticsMenuItems(objectTypesStructure, 'table', menuShow)
            const additionalTableMenuItems: any = defineAdditionalMenuItemsForMainMenu(tableAdditionalItems)
            if (Array.isArray(additionalTableMenuItems)) {
                tableMenuItems = [...tableMenuItems, ...additionalTableMenuItems]
            }
            // Формирование вкладок из раздела "Аналитика"
            const analyticsMenuItems = defineTableOrAnalyticsMenuItems(objectTypesStructure, 'analytics', menuShow)
            // Формирование вкладок из раздела "Дополнительно"
            const additionalGroupsMenuItems = defineAdditionalMenuItemsGroups(additionalMapMenuItems, additionalTableMenuItems, additionalItemsGroups)
            menuStructure.find((menuItem: any) => menuItem.type === 'mapMenu').children.push(...mapMenuItems)
            menuStructure.find((menuItem: any) => menuItem.type === 'tables').children.push(...tableMenuItems)
            menuStructure.find((menuItem: any) => menuItem.type === 'analyticsMenu').children.push(...analyticsMenuItems)
            menuStructure.find((menuItem: any) => menuItem.type === 'additional').children.push(...additionalGroupsMenuItems)
            if (menuAdditionalItems) {
                addDefaultAdditionalMenuItems(menuAdditionalItems, menuStructure)
            }
            menuStructure = getClearedFromHiddenItemsMenuStructure(menuStructure, menuShow)
            menuStructure = getClearedFromEmptySectionsMenuStructure(menuSectionsForEmptyCheck, menuStructure)
            dispatch(setSidebarMenuStructure(menuStructure))
            const sidebarLocalSettings = getItemWebStorage('sidebar')
            const newSidebarSettings = {
                ...sidebarLocalSettings,
                menuStructure
            }
            setItemWebStorage('sidebar', newSidebarSettings)
        } else {
            logoutApp()
        }
    }, [])

    return (
        <div className="menu-list-div">
            {currentMenuItems && currentMenuItems.map((menuItem: any, index: any) => {
                const { type, title, imageIndex, url, children, imageType } = menuItem ?? {}
                const hasChildren = children ? children?.length > 0 : false
                return (
                    <MenuListItem
                        id={`menu-item-${index}`}
                        key={`menu-item-${index}-${title}`}
                        type={type}
                        index={index}
                        title={title}
                        url={url}
                        hasChildren={hasChildren}
                        imageIndex={imageIndex}
                        imageType={imageType}
                    />
                )
            })}
        </div>
    )
}
